// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"7bd6eed3","453":"759b5302"}[chunkId] + ".chunk.js";
};